<app-loader></app-loader>
<div class="close-icon">
  <img src="assets/images/export-close.svg" (click)="closeDialog()" alt="Close"/>
</div>

<div class="booking-summary">
  <div class="itop-header">
    <div class="booking-heading">
      <h3>Booking Summary</h3>

    </div>

  </div>
  <div *ngIf="isParkAnywhere; else showParkingLost" class="parking-lot">
    <p><span>Parking Area - </span>{{area}}</p>
    <h4> Spot - {{slotName}}</h4>
  </div>
  <ng-template #showParkingLost>
    <div class="parking-lot">
      <p><span>Parking Area - </span>{{area}}</p>
      <h4>Spot - {{slotName}}</h4>
    </div>
  </ng-template>

  <div class="summary-table">
    <div class="table-wrapper">
      <table class="table">
        <thead>
          <tr>   
            <th scope="col">{{spotTypeMsg}}</th>
            <th scope="col">License Plate Number</th>
            <th scope="col">Invoice Number</th>
            <th scope="col">Booking Type</th>
            <th scope="col">Arrival<span *ngIf="!(bookingDetail?.bookingType >0 || bookingDetail?.parentId != null)"> and Departure</span> Date/Time</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{vehicleType}}</td>
            <td>{{bookingDetail?.licenseNumberPlate}}</td>
            <td>{{bookingDetail?.invoiceNumber}}</td>
            <td>{{ (bookingDetail?.bookingType >0 || bookingDetail?.parentId != null) ? 'Recurring' : 'One Time' }}</td>
            <td>{{arrivalTime}}<span *ngIf="!(bookingDetail?.bookingType >0 || bookingDetail?.parentId != null)"> To {{departureTime}}</span></td>
          </tr>
          <tr>
  
        </tbody>
      </table>
    </div>
    <div class="discount-table">
      <table>
        <tr>
          <td colspan="8" class="none-mobile"></td>
          <td class="offers-outer"> 
          </td>
          <td class="get-free" *ngIf="bookingDetail?.offer">
            <h4>
              <div class="my-icon" aria-label="My icon" [inlineSVG]="'assets/images/parcentage.svg'"></div>

              {{bookingDetail?.offer?.couponCode}}
            </h4>
            <p>{{bookingDetail?.offer?.summary}}</p>
          </td>
        </tr>
        <tr *ngIf="duration">
          <td colspan="8" class="none-mobile"></td>
          <td>Parking Duration</td>
          <td>{{duration}}</td>
        </tr>
        <tr>
          <td colspan="8" class="none-mobile"></td>
          <td>Amount</td>
          <td *ngIf="!afterApplyOffer">${{amount}}</td>
          <td *ngIf="afterApplyOffer">${{afterApplyOffer.amount.toFixed(2)}}</td>
        </tr>
        <tr *ngIf="discount != '0'">
          <td colspan="8" class="none-mobile"></td>
          <td *ngIf="!afterApplyOffer">Discount</td>
          <td *ngIf="!afterApplyOffer"> - ${{discount}}</td>
        </tr>

        <tr *ngIf="afterApplyOffer?.discount>0">
          <td colspan="8" class="none-mobile"></td>
          <td *ngIf="afterApplyOffer?.discount>0">Discount</td>
          <td *ngIf="afterApplyOffer?.discount>0">-${{afterApplyOffer.discount.toFixed(2)}}</td>
        </tr>

        <tr *ngIf="bookingDetail?.coupanAmount>0">
          <td colspan="8" class="none-mobile"></td>
          <td *ngIf="bookingDetail?.coupanAmount>0">Coupon Discount</td>
          <td *ngIf="bookingDetail?.coupanAmount>0">-${{bookingDetail?.coupanAmount.toFixed(2)}}</td>
        </tr>

        <tr *ngIf="!afterApplyOffer && taxAndFees != 0">
          <td colspan="8" class="none-mobile"></td>
          <td *ngIf="!afterApplyOffer" class="tax-and-fee">Taxes</td>
          <td *ngIf="!afterApplyOffer"> ${{taxAndFees}}</td>
        </tr>
        <tr *ngIf="afterApplyOffer?.taxAndFees>0">
          <td colspan="8" class="none-mobile"></td>
          <td *ngIf="afterApplyOffer?.taxAndFees>0" class="tax-and-fee">Taxes</td>
          <td *ngIf="afterApplyOffer?.taxAndFees >0"> ${{afterApplyOffer?.taxAndFees.toFixed(2)}}</td>
        </tr>  
  
        <tr *ngIf="bookingDetail?.usedCredit > '0'">
          <td colspan="8" class="none-mobile"></td>
          <td>Credit</td>
          <td> - ${{bookingDetail?.usedCredit}}</td>
        </tr>
        <tr  *ngIf="bookingDetail?.transactionFees > '0.00'">
          <td colspan="8" class="none-mobile"></td>
          <td>Transaction Fees</td>
          <td>${{bookingDetail?.transactionFees}}</td>
        </tr>
          <tr *ngIf="bookingDetail?.exemptTaxesAndFees != null && bookingDetail?.exemptTaxesAndFees > 0">
          <td colspan="8" class="none-mobile"></td>
          <td>Exempt Taxes And Fees</td>
          <td>-${{bookingDetail?.exemptTaxesAndFees}}</td>
        </tr>
        <tr *ngIf="bookingDetail?.extendDetail">
          <td colspan="8" class="none-mobile"></td>
          <td>Initial Amount ({{bookingDetail?.initialDuration}})</td>
          <td>${{bookingDetail?.initialTotal}}</td>
        </tr>
        <tr  *ngFor="let item of bookingDetail?.extendDetail">
          <td colspan="8" class="none-mobile"></td>
          <td><div class="add-onamount"><span>Add-on Amount ({{item?.duration}})</span><app-tooltip [tooltipMessage]="addonTooltipTemplate"  [tooltipContext]="{ $implicit: item }" [addClass]="'custom-tooltip-width-addon'"
            (parkingDetailsObj)="getscreenSize($event)"></app-tooltip></div></td>
          <td>${{item?.total}}</td>
        </tr>
        <tr class="total-amount total-note">
          <td>
            <p class="text-left"><span>Note :</span> All pricing in USD </p>
          </td>
          <td colspan="8" class="none-mobile"></td>
          <td>
          <h3 class="total-amount-text" *ngIf="!afterApplyOffer"><span>{{ usedCredit > 0 ? 'Amount + Credits' : 'Total Amount' }}: ${{ total }}</span><span *ngIf="bookingDetail?.usedCredit"><app-tooltip [tooltipMessage]="amountTooltipTemplate"
                                        [addClass]="'custom-tooltip-width-addon'" (parkingDetailsObj)="getscreenSize($event)"></app-tooltip></span></h3>
          <h3 class="total-amount-text" *ngIf="afterApplyOffer"><span>{{ usedCredit > 0 ? 'Amount + Credits' : 'Total Amount' }}: ${{ total }}</span><span *ngIf="bookingDetail?.usedCredit"><app-tooltip [tooltipMessage]="amountTooltipTemplate"
                                        [addClass]="'custom-tooltip-width-addon'" (parkingDetailsObj)="getscreenSize($event)"></app-tooltip></span></h3>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div  *ngIf="shouldDisplayContent()"   class="updated-outerbox">
        <div class="inner-box">
          <div class="changeslot-box">
            <p class="textline">
              Change Spot
            </p>
            <div class="custom-dropdownbox">
              <div class="custom-select2 apply-outer2 disabled">
                <div class="filter-parking header-filter custom-input date-inpu edit-outer">
                  <input  disabled  pInputText [(ngModel)]="slotName" optionLabel="name" optionValue="value" />
                </div>
              </div>
              <p>
                To
              </p>
              <div class="custom-select2 apply-outer2">
                <div class="filter-parking header-filter date-inpu edit-outer">
                  <p-dropdown  [options]="slots" placeholder="Select" optionLabel="name"   [(ngModel)]="selectedSlot"  optionValue="id" emptyMessage="No spots available"></p-dropdown>
                  <img src="assets/images/fill-dropdown.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <p-button label="Update" (onClick)="slotUpdate()"></p-button>
        </div>
      </div>

</div>  
<ng-template #amountTooltipTemplate>
  <div class="tooltip-inner-text" *ngIf="bookingDetail">
    <p>
      <span>Amount</span>
      <span>{{ bookingDetail.total | currency:'USD' }}</span>
    </p>
    <p>
      <span>Credit</span>
      <span>{{ bookingDetail.usedCredit | currency:'USD' }}</span>
    </p>
  </div>
</ng-template>
<ng-template #addonTooltipTemplate let-item>
  <div class="tooltip-heading">
    <h5>Add-on</h5>
    <p>On {{ item?.modifyDate }}</p>
  </div>

  <div class="tooltip-inner-text">
    <p>
      <span>Parking Duration</span>
      <span>{{ item?.duration }}</span>
    </p>
    <p>
      <span>Amount</span>
      <span>{{ item?.amount | currency:'USD' }}</span>
    </p>
    <p>
      <span>Taxes</span>
      <span>{{ item?.taxAndFees | currency:'USD' }}</span>
    </p>
    <p>
      <span>Fees</span>
      <span>{{ item?.transactionFees | currency:'USD' }}</span>
    </p>
  </div>

  <div class="dotes-border">
    <p>
      <span>Total add-on</span>
      <span>{{ item?.total | currency:'USD' }}</span>
    </p>
  </div>
</ng-template>
